/** Hỏi gửi báo cáo crash khi mở game (nếu có hàng đợi và chế độ 'hoi'). */
import type { GameController } from '../game-controller.js';
import { styleNutChinh, styleNutPhu, useCapNhat } from '../dung-chung.js';
import { toast } from './Toast.js';

export function BaoCaoCrashModal(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const soLuong = controller.demBaoCaoCrashCho();
  const cheDo = controller.docDongYCrash();
  if (soLuong === 0 || cheDo !== 'hoi') return null;

  const bamGui = async (): Promise<void> => {
    const ok = await controller.guiBaoCaoCrash();
    toast(ok ? 'Đã gửi báo cáo. Cảm ơn bạn! 🙏' : 'Gửi thất bại, sẽ thử lại sau.');
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        zIndex: 70,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          background: '#241a0e',
          border: '1px solid #8a6a3a',
          borderRadius: '12px',
          padding: '16px',
          maxWidth: '360px',
          color: '#f5e9d0',
        }}
      >
        <h3 style={{ margin: '0 0 8px' }}>⚠️ Game gặp lỗi lần trước</h3>
        <p style={{ fontSize: '13px' }}>
          Có {soLuong} báo cáo lỗi chờ gửi. Báo cáo hoàn toàn ẩn danh (không có thông tin cá nhân).
          Bạn có muốn gửi để giúp sửa lỗi không?
        </p>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button style={styleNutChinh} onClick={bamGui}>
            Gửi
          </button>
          <button style={styleNutPhu} onClick={() => controller.boQuaBaoCaoCrash()}>
            Bỏ qua
          </button>
        </div>
      </div>
    </div>
  );
}
